// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnotherObjModal_modal__ONXSV .modal__inner {
  max-width: 360px;
}
.AnotherObjModal_modal__ONXSV .modal__close-btn {
  top: 0;
  right: -32px;
}

.AnotherObjModal_txt__E8Tfo {
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 20px;
}

.AnotherObjModal_footer__IZIzI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-column-gap: 16px;
}
.AnotherObjModal_footer__IZIzI button:first-child {
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/AnotherObjModal/AnotherObjModal.module.scss"],"names":[],"mappings":"AAGM;EACE,gBAAA;AAFR;AAKM;EACE,MAAA;EACA,YAAA;AAHR;;AASA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AANF;AASI;EACE,SAAA;AAPN","sourcesContent":[".modal {\r\n  :global {\r\n    .modal {\r\n      &__inner {\r\n        max-width: 360px;\r\n      }\r\n\r\n      &__close-btn {\r\n        top: 0;\r\n        right: -32px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.txt {\r\n  font-size: 16px;\r\n  line-height: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  grid-column-gap: 16px;\r\n\r\n  button {\r\n    &:first-child {\r\n      flex: 1;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `AnotherObjModal_modal__ONXSV`,
	"txt": `AnotherObjModal_txt__E8Tfo`,
	"footer": `AnotherObjModal_footer__IZIzI`
};
export default ___CSS_LOADER_EXPORT___;
